exports.default = {
  title_brand: 'PAITEAMS',
  title: 'AI设计师',
  recents: '最近',
  preset_categories: '预设分类',
  show_category_presets: '查看{name}预设',
  category_default_preset_unavailable: '该分类暂无可用的默认预设',
  category_presets_empty: '该分类暂无预设',
  category_presets_load_failed: '预设分类加载失败',
  retry_category_presets: '重试',
  no_recents: '暂无图片生成会话',
  new_image_conversation: '图片生成会话',
  model: '模型',
  auto_model: '自动选择模型',
  auto_model_desc: '自动为您的任务选择最佳图片模型',
  model_default_desc: '适合图片生成、编辑和视觉创作',
  no_image_models: '暂无可用图片模型',
  settings: '设置',
  image_size: '图片尺寸',
  aspect_ratio: '宽高比',
  preset_size: '预设尺寸',
  custom_pixels: '自定义像素',
  custom_pixels_current: '当前尺寸',
  custom_pixels_unit: '像素',
  custom_pixels_width_limit: '宽度范围',
  custom_pixels_height_limit: '高度范围',
  custom_pixels_total_limit: '总像素范围',
  custom_pixels_step_limit: '调整步长',
  custom_pixels_ratio_limit: '长短边比',
  custom_pixels_within_limits: '符合模型限制',
  width: '宽度',
  height: '高度',
  custom_pixels_range: '宽 {minWidth}–{maxWidth} px，高 {minHeight}–{maxHeight} px，步长 {widthStep}/{heightStep}',
  custom_pixels_limit: '总像素 {min}–{max}',
  custom_pixels_required: '请输入宽度和高度',
  custom_pixels_integer: '宽度和高度必须是正整数',
  custom_pixels_width_range: '宽度必须在 {min}–{max} px 范围内',
  custom_pixels_height_range: '高度必须在 {min}–{max} px 范围内',
  custom_pixels_width_step: '宽度必须按 {step} px 对齐',
  custom_pixels_height_step: '高度必须按 {step} px 对齐',
  custom_pixels_min_total: '总像素不能小于 {min}',
  custom_pixels_max_total: '总像素不能超过 {max}',
  custom_pixels_min_ratio: '宽高比不能小于 {min}:1',
  custom_pixels_max_ratio: '长短边比不能超过 {max}:1',
  custom_pixels_invalid: '自定义像素不符合当前模型限制',
  auto_style: '自动风格',
  search_style: '搜索风格...',
  camera: '相机',
  camera_body: '机身',
  lens: '镜头',
  focal_length: '焦距',
  aperture: '光圈',
  auto_prompt: '自动提示词',
  prompt_placeholder: '一只可爱的小猫在玩毛线球',
  generate: '生成',
  quick_apps: '快捷应用',
  view_all: '查看全部',
  no_cases: '暂无案例',
  all: '全部',
  album: '专辑',
  album_case_count: '共 {count} 个作品',
  recommended_albums: '推荐专辑',
  search_related_albums: '相关专辑',
  search_related_cases: '相关案例',
  search_case_count: '找到 {count} 个案例',
  clear_search: '清除搜索',
  back_to_image_generation: '返回 AI 图片',
  sort_cases: '案例排序',
  sort_popular: '热门',
  sort_latest: '最新',
  sort_default: '默认',
  case_inspiration: '灵感',
  case_short: '短片',
  case_activity: '活动',
  case_search_placeholder: '搜索灵感',
  hot_category_previous: '上一组热门案例',
  hot_category_next: '下一组热门案例',
  hot_category_empty: '该分类暂无案例',
  prompt: '提示词',
  image_prompt: '图片提示词',
  quality: '质量',
  size: '尺寸',
  recreate: '重新创建',
  same_style: '做同款',
  use_as_reference: '用作参考图',
  more: '更多',
  previous_case: '上一张',
  next_case: '下一张',
  case_detail: '案例详情',
  loading: '加载中',
  conversation: '对话过程',
  you: '你',
  assistant: '助手',
  continue_conversation: '继续对话',
  make_same: '做同款',
  conversation_unavailable: '该案例暂无可继续对话的内容',
  conversation_create_failed: '新会话创建失败',
  reference_image_unavailable: '该案例暂不能作为参考图',
  video: '生成视频',
  download: '下载',
  zoom: '放大',
  edit: '编辑',
  save: '保存',
  copy: '复制',
  max_upload_images: '最多上传 {count} 张参考图',
  reference_image_upload_hint: '单张图片大小不超过 20MB，当前模型最多上传 {count} 张参考图。',
  reference_image_limit_exceeded: '当前模型最多支持 {max} 张参考图，已选择 {actual} 张，请移除 {remove} 张。',
  invalid_image_format: '图片格式必须是 PNG、JPEG、JPG 或 WebP',
  image_size_limit: '图片大小不能超过 20MB',
  upload_failed: '图片上传失败',
  no_entry_agent: '未找到图片生成入口智能体',
  no_image_model_selected: '请选择图片模型',
  quick_background_remove: '背景移除',
  quick_background_remove_prompt: '移除图片背景，保留主体并让边缘自然干净。',
  quick_magic_retouch: '魔法橡皮擦',
  quick_magic_retouch_prompt: '修复图片中不需要的区域，保持画面材质和光线自然。',
  quick_scene_redraw: '魔法重绘',
  quick_scene_redraw_prompt: '重新绘制画面，增强细节、氛围和构图完整度。',
  quick_photo_deblur: '照片去模糊',
  quick_photo_deblur_prompt: '提升照片清晰度，恢复人物、物体和背景细节。',
  quick_image_expand: '图片扩展',
  quick_image_expand_prompt: '自然扩展图片边界，延展背景和场景内容。',
  skills: '技能',
  all_skills: '全部技能',
  loading_skills: '技能加载中',
  no_skills: '暂无可用技能',
  recently_opened: '最近打开',
  back_to_categories: '返回分类'
}
